import React, { createContext, useState, useEffect } from "react";
import { sanitizeInput } from "./../actions/search.actions";

export const GlobalContext = createContext(null);

export const GlobalProvider = ({ children }) => {

	const [state, setState] = useState({
		searchString: '',
		results: [],
		promotions: [],
		showSearch: false,
		showSearchHeader: false,
		showModal: false,
		showSpiner: true
	});

	const searchRecommendation = (e, modal = false, position = "header") => {

		setState((prevState) => ({
			...prevState,
			searchString: e.target.value,
		}));


		let value = e.target.value.trim();

		if (value.length > 2) {

			value = sanitizeInput(value); // Clean input before using

			if (value.length > 2) {

				getSearchRecommendation(value, modal, position);

			} else {

				setState((prevState) => ({
					...prevState,
					showSearch: false,
					showSearchHeader: false
				}));

			}

		} else {

			setState((prevState) => ({
				...prevState,
				showSearch: false,
				showSearchHeader: false
			}));

		}

	};

	const getSearchRecommendation = (searchString, modal = false, position = 'header') => {

		const requestOptions = {
			method: "GET",
			redirect: "follow"
		};

		setState((prevState) => ({
			...prevState,
			showSpiner: true
		}));

		fetch(`https://eservice2.pwcva.gov/apps/azure.search/api/search/semantic/${encodeURIComponent(searchString)}`, requestOptions)
		.then((res) => res.json())
		.then((data) => {

			let showSearch = false;
			let showSearchHeader = false;

			if ((data?.promotions?.length > 0 || data?.results?.length > 0) && !modal) {

				if(position === 'header'){
					showSearchHeader = true;
				} else {
					showSearch = true;
				}
			}

			if(state.showModal){
				showSearch = false;
				showSearchHeader = false;
			}

			setState((prevState) => ({
				...prevState,
				results: data?.results,
				promotions: data?.promotions,
				showSearch: showSearch,
				showSearchHeader: showSearchHeader,
				showSpiner: false
			}));

		})
		.catch((error) => {

			setState((prevState) => ({
				...prevState,
				showSearch: false,
				showSearchHeader: false
			}));

			console.log(error);
		});

	};

	return (
		<GlobalContext.Provider value={{ state, setState, searchRecommendation, getSearchRecommendation }}>
			{children}
		</GlobalContext.Provider>
	);
};